import platformConfig from '/config/platform.config';
import {isProdEnvironment} from '/util/env.util';

const IOS_APP_TEST_ID = '064fd6d8-79d3-4cba-a12b-c66d6736158b-test';
const ANDROID_APP_TEST_ID = '30165a7e-4884-4f88-b052-68b12ea90109-test';
const IOS_APP_PROD_ID = '064fd6d8-79d3-4cba-a12b-c66d6736158b';
const ANDROID_APP_PROD_ID = '30165a7e-4884-4f88-b052-68b12ea90109';

export const TEALIUM_SDK_ID = '3ece5493-4e1b-44e8-9742-53dc635d91ee';
export const FULLSTORY_SDK_ID = '91f73186-0e6f-4687-9ab1-0626c46a202e';
export const QUALTRICS_SDK_ID = '993b4d12-4efa-4640-9a15-90afba43bb96';
export const FIREBASE_PERF_SDK_ID = '62704f67-f94e-4644-ad8f-be67687f5d83';
export const FIREBASE_SDK_ID = 'deb59ec4-97b4-47a0-a507-0809a9678777';

export const getAppID = () => {
  if (isProdEnvironment()) {
    return platformConfig.select({
      ios: IOS_APP_PROD_ID,
      android: ANDROID_APP_PROD_ID,
    });
  } else {
    return platformConfig.select({
      ios: IOS_APP_TEST_ID,
      android: ANDROID_APP_TEST_ID,
    });
  }
};
